import { COLOR_PALETTE } from 'constants/ui';

export const LabelVariant = Object.keys(COLOR_PALETTE).reduce((acc, key) => {
  acc[key] = key;

  return acc;
}, {});

export const LabelSize = {
  S: 'S',
  M: 'M',
  L: 'L',
};

export const LabelBorderStyle = {
  SOLID: 'solid',
  DOTTED: 'dotted',
  DASHED: 'dashed',
};

export const TypographyVariant = {
  [LabelSize.S]: 'regular12',
  [LabelSize.M]: 'regular14',
  [LabelSize.L]: 'regular16',
};

export const DEFAULT_COLOR_MATCH = {
  backgroundColor: 2,
  color: 8,
  borderColor: 5,
};
